import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getCheatedBets=(betId,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_CHEATED_BETS_START,
    })
    const options={
        url:`${api}/bets/${betId}/cheatedBets`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_CHEATED_BETS_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_CHEATED_BETS_FAIL,
                payload:getMessage(error)
            }))
}